import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import { authorizationPaymentResponse } from '../mockData/authorizePaymentResultData';

export const authorizedPaymentHandler: RestHandler[] = [
  rest.post(PATHS.getAuthorizeVccPay(), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(authorizationPaymentResponse))
  )
];
